export const espnteams2 = [
  {
    "year": 2024,
    "team": "Notre Dame",
    "conference": "FBS Independents",
    "fpi": 25.305,
    "resumeRanks": {
      "strengthOfRecord": 4,
      "fpi": 2,
      "averageWinProbability": 2,
      "strengthOfSchedule": 58,
      "remainingStrengthOfSchedule": null,
      "gameControl": 4
    },
    "efficiencies": {
      "overall": 88.314,
      "offense": 78.053,
      "defense": 88.226,
      "specialTeams": 42.499
    }
  },
  {
    "year": 2024,
    "team": "Massachusetts",
    "conference": "FBS Independents",
    "fpi": -17.327,
    "resumeRanks": {
      "strengthOfRecord": 131,
      "fpi": 125,
      "averageWinProbability": 115,
      "strengthOfSchedule": 76,
      "remainingStrengthOfSchedule": null,
      "gameControl": 120
    },
    "efficiencies": {
      "overall": 21.134,
      "offense": 44.861,
      "defense": 17.921,
      "specialTeams": 18.122
    }
  },
  {
    "year": 2024,
    "team": "Oklahoma State",
    "conference": "Big 12",
    "fpi": -0.188,
    "resumeRanks": {
      "strengthOfRecord": 99,
      "fpi": 69,
      "averageWinProbability": 121,
      "strengthOfSchedule": 38,
      "remainingStrengthOfSchedule": null,
      "gameControl": 88
    },
    "efficiencies": {
      "overall": 45.41,
      "offense": 60.308,
      "defense": 33.797,
      "specialTeams": 50.114
    }
  },
  {
    "year": 2024,
    "team": "Kansas State",
    "conference": "Big 12",
    "fpi": 11.098,
    "resumeRanks": {
      "strengthOfRecord": 31,
      "fpi": 24,
      "averageWinProbability": 52,
      "strengthOfSchedule": 47,
      "remainingStrengthOfSchedule": null,
      "gameControl": 33
    },
    "efficiencies": {
      "overall": 70.634,
      "offense": 61.856,
      "defense": 71.635,
      "specialTeams": 49.804
    }
  },
  {
    "year": 2024,
    "team": "Baylor",
    "conference": "Big 12",
    "fpi": 9.105,
    "resumeRanks": {
      "strengthOfRecord": 35,
      "fpi": 33,
      "averageWinProbability": 35,
      "strengthOfSchedule": 63,
      "remainingStrengthOfSchedule": null,
      "gameControl": 27
    },
    "efficiencies": {
      "overall": 70.789,
      "offense": 70.321,
      "defense": 56.691,
      "specialTeams": 72.021
    }
  },
  {
    "year": 2024,
    "team": "Iowa State",
    "conference": "Big 12",
    "fpi": 10.15,
    "resumeRanks": {
      "strengthOfRecord": 23,
      "fpi": 28,
      "averageWinProbability": 58,
      "strengthOfSchedule": 57,
      "remainingStrengthOfSchedule": null,
      "gameControl": 53
    },
    "efficiencies": {
      "overall": 66.812,
      "offense": 63.385,
      "defense": 63.427,
      "specialTeams": 52.51
    }
  },
  {
    "year": 2024,
    "team": "Texas Tech",
    "conference": "Big 12",
    "fpi": 6.204,
    "resumeRanks": {
      "strengthOfRecord": 37,
      "fpi": 40,
      "averageWinProbability": 33,
      "strengthOfSchedule": 69,
      "remainingStrengthOfSchedule": null,
      "gameControl": 35
    },
    "efficiencies": {
      "overall": 57.272,
      "offense": 59.502,
      "defense": 48.684,
      "specialTeams": 59.274
    }
  },
  {
    "year": 2024,
    "team": "Kansas",
    "conference": "Big 12",
    "fpi": 8.755,
    "resumeRanks": {
      "strengthOfRecord": 61,
      "fpi": 35,
      "averageWinProbability": 43,
      "strengthOfSchedule": 37,
      "remainingStrengthOfSchedule": null,
      "gameControl": 23
    },
    "efficiencies": {
      "overall": 66.926,
      "offense": 75.105,
      "defense": 52.224,
      "specialTeams": 46.186
    }
  },
  {
    "year": 2024,
    "team": "TCU",
    "conference": "Big 12",
    "fpi": 8.023,
    "resumeRanks": {
      "strengthOfRecord": 38,
      "fpi": 37,
      "averageWinProbability": 42,
      "strengthOfSchedule": 61,
      "remainingStrengthOfSchedule": null,
      "gameControl": 38
    },
    "efficiencies": {
      "overall": 67.255,
      "offense": 69.28,
      "defense": 58.063,
      "specialTeams": 52.483
    }
  },
  {
    "year": 2024,
    "team": "West Virginia",
    "conference": "Big 12",
    "fpi": 1.795,
    "resumeRanks": {
      "strengthOfRecord": 56,
      "fpi": 63,
      "averageWinProbability": 76,
      "strengthOfSchedule": 52,
      "remainingStrengthOfSchedule": 2,
      "gameControl": 56
    },
    "efficiencies": {
      "overall": 52.984,
      "offense": 64.597,
      "defense": 35.526,
      "specialTeams": 62.429
    }
  },
  {
    "year": 2024,
    "team": "South Florida",
    "conference": "American Athletic",
    "fpi": -3.472,
    "resumeRanks": {
      "strengthOfRecord": 86,
      "fpi": 83,
      "averageWinProbability": 99,
      "strengthOfSchedule": 59,
      "remainingStrengthOfSchedule": 13,
      "gameControl": 106
    },
    "efficiencies": {
      "overall": 43.944,
      "offense": 38.512,
      "defense": 48.325,
      "specialTeams": 59.807
    }
  },
  {
    "year": 2024,
    "team": "East Carolina",
    "conference": "American Athletic",
    "fpi": -5.922,
    "resumeRanks": {
      "strengthOfRecord": 90,
      "fpi": 93,
      "averageWinProbability": 71,
      "strengthOfSchedule": 129,
      "remainingStrengthOfSchedule": null,
      "gameControl": 101
    },
    "efficiencies": {
      "overall": 41.022,
      "offense": 32.234,
      "defense": 48.38,
      "specialTeams": 64.194
    }
  },
  {
    "year": 2024,
    "team": "Tulsa",
    "conference": "American Athletic",
    "fpi": -23.104,
    "resumeRanks": {
      "strengthOfRecord": 129,
      "fpi": 133,
      "averageWinProbability": 131,
      "strengthOfSchedule": 132,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 10.676,
      "offense": 13.203,
      "defense": 19.054,
      "specialTeams": 46.728
    }
  },
  {
    "year": 2024,
    "team": "Temple",
    "conference": "American Athletic",
    "fpi": -18.721,
    "resumeRanks": {
      "strengthOfRecord": 119,
      "fpi": 127,
      "averageWinProbability": 127,
      "strengthOfSchedule": 95,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 21.167,
      "offense": 12.845,
      "defense": 40.982,
      "specialTeams": 52.686
    }
  },
  {
    "year": 2024,
    "team": "Memphis",
    "conference": "American Athletic",
    "fpi": 2.129,
    "resumeRanks": {
      "strengthOfRecord": 33,
      "fpi": 62,
      "averageWinProbability": 12,
      "strengthOfSchedule": 114,
      "remainingStrengthOfSchedule": 3,
      "gameControl": 40
    },
    "efficiencies": {
      "overall": 54.221,
      "offense": 59.509,
      "defense": 47.876,
      "specialTeams": 44.037
    }
  },
  {
    "year": 2024,
    "team": "Navy",
    "conference": "American Athletic",
    "fpi": -0.331,
    "resumeRanks": {
      "strengthOfRecord": 41,
      "fpi": 70,
      "averageWinProbability": 21,
      "strengthOfSchedule": 86,
      "remainingStrengthOfSchedule": null,
      "gameControl": 48
    },
    "efficiencies": {
      "overall": 66.294,
      "offense": 67.98,
      "defense": 60.609,
      "specialTeams": 42.503
    }
  },
  {
    "year": 2024,
    "team": "Tulane",
    "conference": "American Athletic",
    "fpi": 10.537,
    "resumeRanks": {
      "strengthOfRecord": 49,
      "fpi": 27,
      "averageWinProbability": 17,
      "strengthOfSchedule": 93,
      "remainingStrengthOfSchedule": null,
      "gameControl": 44
    },
    "efficiencies": {
      "overall": 71.379,
      "offense": 66.845,
      "defense": 65.053,
      "specialTeams": 60.698
    }
  },
  {
    "year": 2024,
    "team": "Western Kentucky",
    "conference": "Conference USA",
    "fpi": -7.663,
    "resumeRanks": {
      "strengthOfRecord": 78,
      "fpi": 102,
      "averageWinProbability": 54,
      "strengthOfSchedule": 78,
      "remainingStrengthOfSchedule": 1,
      "gameControl": 79
    },
    "efficiencies": {
      "overall": 43.781,
      "offense": 43.864,
      "defense": 42.926,
      "specialTeams": 60.821
    }
  },
  {
    "year": 2024,
    "team": "Florida International",
    "conference": "Conference USA",
    "fpi": -11.982,
    "resumeRanks": {
      "strengthOfRecord": 125,
      "fpi": 116,
      "averageWinProbability": 73,
      "strengthOfSchedule": 104,
      "remainingStrengthOfSchedule": null,
      "gameControl": 105
    },
    "efficiencies": {
      "overall": 31.486,
      "offense": 26.115,
      "defense": 42.649,
      "specialTeams": 52.169
    }
  },
  {
    "year": 2024,
    "team": "Louisiana Tech",
    "conference": "Conference USA",
    "fpi": -10.693,
    "resumeRanks": {
      "strengthOfRecord": 116,
      "fpi": 109,
      "averageWinProbability": 79,
      "strengthOfSchedule": 124,
      "remainingStrengthOfSchedule": null,
      "gameControl": 109
    },
    "efficiencies": {
      "overall": 33.559,
      "offense": 17.782,
      "defense": 57.468,
      "specialTeams": 56.881
    }
  },
  {
    "year": 2024,
    "team": "Middle Tennessee",
    "conference": "Conference USA",
    "fpi": -19.398,
    "resumeRanks": {
      "strengthOfRecord": 126,
      "fpi": 128,
      "averageWinProbability": 130,
      "strengthOfSchedule": 90,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 12.733,
      "offense": 20.907,
      "defense": 13.889,
      "specialTeams": 61.424
    }
  },
  {
    "year": 2024,
    "team": "UTEP",
    "conference": "Conference USA",
    "fpi": -19.407,
    "resumeRanks": {
      "strengthOfRecord": 128,
      "fpi": 129,
      "averageWinProbability": 120,
      "strengthOfSchedule": 89,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 18.38,
      "offense": 12.952,
      "defense": 39.066,
      "specialTeams": 39.932
    }
  },
  {
    "year": 2024,
    "team": "Oregon State",
    "conference": "Pac-12",
    "fpi": -6.875,
    "resumeRanks": {
      "strengthOfRecord": 104,
      "fpi": 96,
      "averageWinProbability": 95,
      "strengthOfSchedule": 85,
      "remainingStrengthOfSchedule": null,
      "gameControl": 96
    },
    "efficiencies": {
      "overall": 30.065,
      "offense": 41.308,
      "defense": 25.791,
      "specialTeams": 50.932
    }
  },
  {
    "year": 2024,
    "team": "Washington State",
    "conference": "Pac-12",
    "fpi": 1.667,
    "resumeRanks": {
      "strengthOfRecord": 60,
      "fpi": 64,
      "averageWinProbability": 25,
      "strengthOfSchedule": 111,
      "remainingStrengthOfSchedule": null,
      "gameControl": 55
    },
    "efficiencies": {
      "overall": 55.471,
      "offense": 65.831,
      "defense": 46.227,
      "specialTeams": 40.813
    }
  },
  {
    "year": 2024,
    "team": "James Madison",
    "conference": "Sun Belt",
    "fpi": 2.903,
    "resumeRanks": {
      "strengthOfRecord": 69,
      "fpi": 57,
      "averageWinProbability": 19,
      "strengthOfSchedule": 127,
      "remainingStrengthOfSchedule": 10,
      "gameControl": 62
    },
    "efficiencies": {
      "overall": 53.163,
      "offense": 41.053,
      "defense": 62.727,
      "specialTeams": 55.265
    }
  },
  {
    "year": 2024,
    "team": "Marshall",
    "conference": "Sun Belt",
    "fpi": 2.784,
    "resumeRanks": {
      "strengthOfRecord": 32,
      "fpi": 58,
      "averageWinProbability": 22,
      "strengthOfSchedule": 64,
      "remainingStrengthOfSchedule": null,
      "gameControl": 42
    },
    "efficiencies": {
      "overall": 60.561,
      "offense": 56.322,
      "defense": 55.867,
      "specialTeams": 64.691
    }
  },
  {
    "year": 2024,
    "team": "Georgia Southern",
    "conference": "Sun Belt",
    "fpi": -2.353,
    "resumeRanks": {
      "strengthOfRecord": 50,
      "fpi": 76,
      "averageWinProbability": 80,
      "strengthOfSchedule": 80,
      "remainingStrengthOfSchedule": 8,
      "gameControl": 75
    },
    "efficiencies": {
      "overall": 49.887,
      "offense": 52.067,
      "defense": 44.55,
      "specialTeams": 60.616
    }
  },
  {
    "year": 2024,
    "team": "Old Dominion",
    "conference": "Sun Belt",
    "fpi": -2.342,
    "resumeRanks": {
      "strengthOfRecord": 102,
      "fpi": 75,
      "averageWinProbability": 85,
      "strengthOfSchedule": 96,
      "remainingStrengthOfSchedule": null,
      "gameControl": 81
    },
    "efficiencies": {
      "overall": 48.449,
      "offense": 49.828,
      "defense": 49.644,
      "specialTeams": 44.282
    }
  },
  {
    "year": 2024,
    "team": "Coastal Carolina",
    "conference": "Sun Belt",
    "fpi": -6.068,
    "resumeRanks": {
      "strengthOfRecord": 97,
      "fpi": 94,
      "averageWinProbability": 81,
      "strengthOfSchedule": 120,
      "remainingStrengthOfSchedule": null,
      "gameControl": 93
    },
    "efficiencies": {
      "overall": 42.26,
      "offense": 45.227,
      "defense": 44.594,
      "specialTeams": 42.766
    }
  },
  {
    "year": 2024,
    "team": "App State",
    "conference": "Sun Belt",
    "fpi": -6.788,
    "resumeRanks": {
      "strengthOfRecord": 87,
      "fpi": 95,
      "averageWinProbability": 123,
      "strengthOfSchedule": 99,
      "remainingStrengthOfSchedule": null,
      "gameControl": 116
    },
    "efficiencies": {
      "overall": 34.071,
      "offense": 48.691,
      "defense": 27.315,
      "specialTeams": 43.31
    }
  },
  {
    "year": 2024,
    "team": "Georgia State",
    "conference": "Sun Belt",
    "fpi": -10.248,
    "resumeRanks": {
      "strengthOfRecord": 115,
      "fpi": 107,
      "averageWinProbability": 114,
      "strengthOfSchedule": 101,
      "remainingStrengthOfSchedule": null,
      "gameControl": 117
    },
    "efficiencies": {
      "overall": 28.969,
      "offense": 40.888,
      "defense": 28.455,
      "specialTeams": 37.82
    }
  },
  {
    "year": 2024,
    "team": "South Alabama",
    "conference": "Sun Belt",
    "fpi": 0.261,
    "resumeRanks": {
      "strengthOfRecord": 100,
      "fpi": 66,
      "averageWinProbability": 46,
      "strengthOfSchedule": 110,
      "remainingStrengthOfSchedule": 14,
      "gameControl": 72
    },
    "efficiencies": {
      "overall": 50.616,
      "offense": 54.12,
      "defense": 47.873,
      "specialTeams": 47.236
    }
  },
  {
    "year": 2024,
    "team": "Louisiana",
    "conference": "Sun Belt",
    "fpi": -0.152,
    "resumeRanks": {
      "strengthOfRecord": 48,
      "fpi": 68,
      "averageWinProbability": 28,
      "strengthOfSchedule": 119,
      "remainingStrengthOfSchedule": null,
      "gameControl": 71
    },
    "efficiencies": {
      "overall": 57.349,
      "offense": 68.046,
      "defense": 40.445,
      "specialTeams": 58.521
    }
  },
  {
    "year": 2024,
    "team": "Texas State",
    "conference": "Sun Belt",
    "fpi": 2.247,
    "resumeRanks": {
      "strengthOfRecord": 84,
      "fpi": 61,
      "averageWinProbability": 14,
      "strengthOfSchedule": 122,
      "remainingStrengthOfSchedule": null,
      "gameControl": 57
    },
    "efficiencies": {
      "overall": 54.407,
      "offense": 61.077,
      "defense": 48.418,
      "specialTeams": 40.097
    }
  },
  {
    "year": 2024,
    "team": "Arkansas State",
    "conference": "Sun Belt",
    "fpi": -11.861,
    "resumeRanks": {
      "strengthOfRecord": 71,
      "fpi": 115,
      "averageWinProbability": 96,
      "strengthOfSchedule": 98,
      "remainingStrengthOfSchedule": null,
      "gameControl": 103
    },
    "efficiencies": {
      "overall": 27.049,
      "offense": 38.921,
      "defense": 22.972,
      "specialTeams": 53.085
    }
  },
  {
    "year": 2024,
    "team": "UL Monroe",
    "conference": "Sun Belt",
    "fpi": -11.333,
    "resumeRanks": {
      "strengthOfRecord": 96,
      "fpi": 113,
      "averageWinProbability": 104,
      "strengthOfSchedule": 56,
      "remainingStrengthOfSchedule": null,
      "gameControl": 98
    },
    "efficiencies": {
      "overall": 33.63,
      "offense": 31.24,
      "defense": 43.181,
      "specialTeams": 45.167
    }
  },
  {
    "year": 2024,
    "team": "Southern Miss",
    "conference": "Sun Belt",
    "fpi": -21.712,
    "resumeRanks": {
      "strengthOfRecord": 132,
      "fpi": 132,
      "averageWinProbability": 132,
      "strengthOfSchedule": 108,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 11.99,
      "offense": 12.972,
      "defense": 20.399,
      "specialTeams": 54.495
    }
  },
  {
    "year": 2024,
    "team": "Troy",
    "conference": "Sun Belt",
    "fpi": -7.249,
    "resumeRanks": {
      "strengthOfRecord": 113,
      "fpi": 99,
      "averageWinProbability": 105,
      "strengthOfSchedule": 106,
      "remainingStrengthOfSchedule": null,
      "gameControl": 112
    },
    "efficiencies": {
      "overall": 32.041,
      "offense": 43.518,
      "defense": 32.267,
      "specialTeams": 33.956
    }
  },
  {
    "year": 2024,
    "team": "UConn",
    "conference": "FBS Independents",
    "fpi": -3.325,
    "resumeRanks": {
      "strengthOfRecord": 74,
      "fpi": 79,
      "averageWinProbability": 69,
      "strengthOfSchedule": 126,
      "remainingStrengthOfSchedule": null,
      "gameControl": 100
    },
    "efficiencies": {
      "overall": 47.273,
      "offense": 35.591,
      "defense": 58.188,
      "specialTeams": 54.648
    }
  },
  {
    "year": 2024,
    "team": "BYU",
    "conference": "Big 12",
    "fpi": 9.307,
    "resumeRanks": {
      "strengthOfRecord": 12,
      "fpi": 32,
      "averageWinProbability": 24,
      "strengthOfSchedule": 42,
      "remainingStrengthOfSchedule": null,
      "gameControl": 19
    },
    "efficiencies": {
      "overall": 74.278,
      "offense": 67.062,
      "defense": 70.631,
      "specialTeams": 58.08
    }
  },
  {
    "year": 2024,
    "team": "Cincinnati",
    "conference": "Big 12",
    "fpi": 3.423,
    "resumeRanks": {
      "strengthOfRecord": 67,
      "fpi": 56,
      "averageWinProbability": 74,
      "strengthOfSchedule": 46,
      "remainingStrengthOfSchedule": null,
      "gameControl": 51
    },
    "efficiencies": {
      "overall": 58.625,
      "offense": 63.495,
      "defense": 54.814,
      "specialTeams": 34.682
    }
  },
  {
    "year": 2024,
    "team": "Houston",
    "conference": "Big 12",
    "fpi": -3.444,
    "resumeRanks": {
      "strengthOfRecord": 79,
      "fpi": 82,
      "averageWinProbability": 117,
      "strengthOfSchedule": 41,
      "remainingStrengthOfSchedule": null,
      "gameControl": 83
    },
    "efficiencies": {
      "overall": 43.566,
      "offense": 25.038,
      "defense": 65.249,
      "specialTeams": 48.814
    }
  },
  {
    "year": 2024,
    "team": "UCF",
    "conference": "Big 12",
    "fpi": 5.283,
    "resumeRanks": {
      "strengthOfRecord": 89,
      "fpi": 43,
      "averageWinProbability": 101,
      "strengthOfSchedule": 45,
      "remainingStrengthOfSchedule": null,
      "gameControl": 74
    },
    "efficiencies": {
      "overall": 53.294,
      "offense": 60.369,
      "defense": 50.721,
      "specialTeams": 32.002
    }
  },
  {
    "year": 2024,
    "team": "UAB",
    "conference": "American Athletic",
    "fpi": -12.74,
    "resumeRanks": {
      "strengthOfRecord": 122,
      "fpi": 118,
      "averageWinProbability": 102,
      "strengthOfSchedule": 102,
      "remainingStrengthOfSchedule": null,
      "gameControl": 110
    },
    "efficiencies": {
      "overall": 28.025,
      "offense": 29.047,
      "defense": 32.357,
      "specialTeams": 57.606
    }
  },
  {
    "year": 2024,
    "team": "Florida Atlantic",
    "conference": "American Athletic",
    "fpi": -12.288,
    "resumeRanks": {
      "strengthOfRecord": 130,
      "fpi": 117,
      "averageWinProbability": 97,
      "strengthOfSchedule": 130,
      "remainingStrengthOfSchedule": null,
      "gameControl": 123
    },
    "efficiencies": {
      "overall": 23.757,
      "offense": 26.337,
      "defense": 35.512,
      "specialTeams": 31.548
    }
  },
  {
    "year": 2024,
    "team": "Charlotte",
    "conference": "American Athletic",
    "fpi": -13.522,
    "resumeRanks": {
      "strengthOfRecord": 101,
      "fpi": 120,
      "averageWinProbability": 122,
      "strengthOfSchedule": 82,
      "remainingStrengthOfSchedule": null,
      "gameControl": 118
    },
    "efficiencies": {
      "overall": 27.766,
      "offense": 32.18,
      "defense": 25.782,
      "specialTeams": 68.735
    }
  },
  {
    "year": 2024,
    "team": "North Texas",
    "conference": "American Athletic",
    "fpi": -7.287,
    "resumeRanks": {
      "strengthOfRecord": 91,
      "fpi": 100,
      "averageWinProbability": 88,
      "strengthOfSchedule": 109,
      "remainingStrengthOfSchedule": null,
      "gameControl": 99
    },
    "efficiencies": {
      "overall": 39.308,
      "offense": 51.932,
      "defense": 32.261,
      "specialTeams": 46.927
    }
  },
  {
    "year": 2024,
    "team": "Rice",
    "conference": "American Athletic",
    "fpi": -8.58,
    "resumeRanks": {
      "strengthOfRecord": 110,
      "fpi": 104,
      "averageWinProbability": 89,
      "strengthOfSchedule": 100,
      "remainingStrengthOfSchedule": null,
      "gameControl": 94
    },
    "efficiencies": {
      "overall": 34.128,
      "offense": 27.275,
      "defense": 53.023,
      "specialTeams": 34.236
    }
  },
  {
    "year": 2024,
    "team": "UTSA",
    "conference": "American Athletic",
    "fpi": -5.581,
    "resumeRanks": {
      "strengthOfRecord": 98,
      "fpi": 92,
      "averageWinProbability": 48,
      "strengthOfSchedule": 71,
      "remainingStrengthOfSchedule": null,
      "gameControl": 70
    },
    "efficiencies": {
      "overall": 40.078,
      "offense": 38.259,
      "defense": 46.39,
      "specialTeams": 49.382
    }
  },
  {
    "year": 2024,
    "team": "Jacksonville State",
    "conference": "Conference USA",
    "fpi": -0.913,
    "resumeRanks": {
      "strengthOfRecord": 72,
      "fpi": 72,
      "averageWinProbability": 44,
      "strengthOfSchedule": 113,
      "remainingStrengthOfSchedule": 9,
      "gameControl": 89
    },
    "efficiencies": {
      "overall": 47.628,
      "offense": 57.904,
      "defense": 42.655,
      "specialTeams": 37.194
    }
  },
  {
    "year": 2024,
    "team": "Liberty",
    "conference": "Conference USA",
    "fpi": -6.943,
    "resumeRanks": {
      "strengthOfRecord": 77,
      "fpi": 97,
      "averageWinProbability": 78,
      "strengthOfSchedule": 134,
      "remainingStrengthOfSchedule": 12,
      "gameControl": 124
    },
    "efficiencies": {
      "overall": 35.985,
      "offense": 45.362,
      "defense": 33.328,
      "specialTeams": 44.461
    }
  },
  {
    "year": 2024,
    "team": "New Mexico State",
    "conference": "Conference USA",
    "fpi": -20.775,
    "resumeRanks": {
      "strengthOfRecord": 127,
      "fpi": 130,
      "averageWinProbability": 124,
      "strengthOfSchedule": 107,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 14.39,
      "offense": 18.985,
      "defense": 20.899,
      "specialTeams": 44.223
    }
  },
  {
    "year": 2024,
    "team": "Sam Houston",
    "conference": "Conference USA",
    "fpi": -6.961,
    "resumeRanks": {
      "strengthOfRecord": 55,
      "fpi": 98,
      "averageWinProbability": 55,
      "strengthOfSchedule": 123,
      "remainingStrengthOfSchedule": 4,
      "gameControl": 86
    },
    "efficiencies": {
      "overall": 43.45,
      "offense": 29.883,
      "defense": 63.554,
      "specialTeams": 40.218
    }
  },
  {
    "year": 2024,
    "team": "Army",
    "conference": "American Athletic",
    "fpi": 5.27,
    "resumeRanks": {
      "strengthOfRecord": 16,
      "fpi": 44,
      "averageWinProbability": 4,
      "strengthOfSchedule": 94,
      "remainingStrengthOfSchedule": null,
      "gameControl": 15
    },
    "efficiencies": {
      "overall": 75.619,
      "offense": 78.841,
      "defense": 58.952,
      "specialTeams": 54.629
    }
  },
  {
    "year": 2024,
    "team": "Stanford",
    "conference": "ACC",
    "fpi": -5.299,
    "resumeRanks": {
      "strengthOfRecord": 95,
      "fpi": 90,
      "averageWinProbability": 119,
      "strengthOfSchedule": 17,
      "remainingStrengthOfSchedule": null,
      "gameControl": 85
    },
    "efficiencies": {
      "overall": 38.36,
      "offense": 36.975,
      "defense": 39.874,
      "specialTeams": 65.408
    }
  },
  {
    "year": 2024,
    "team": "California",
    "conference": "ACC",
    "fpi": 4.302,
    "resumeRanks": {
      "strengthOfRecord": 68,
      "fpi": 51,
      "averageWinProbability": 64,
      "strengthOfSchedule": 66,
      "remainingStrengthOfSchedule": null,
      "gameControl": 60
    },
    "efficiencies": {
      "overall": 57.687,
      "offense": 45.477,
      "defense": 64.264,
      "specialTeams": 58.117
    }
  },
  {
    "year": 2024,
    "team": "Florida State",
    "conference": "ACC",
    "fpi": -3.911,
    "resumeRanks": {
      "strengthOfRecord": 106,
      "fpi": 85,
      "averageWinProbability": 126,
      "strengthOfSchedule": 11,
      "remainingStrengthOfSchedule": null,
      "gameControl": 97
    },
    "efficiencies": {
      "overall": 35.518,
      "offense": 23.689,
      "defense": 45.332,
      "specialTeams": 73.417
    }
  },
  {
    "year": 2024,
    "team": "Georgia Tech",
    "conference": "ACC",
    "fpi": 7.402,
    "resumeRanks": {
      "strengthOfRecord": 34,
      "fpi": 38,
      "averageWinProbability": 56,
      "strengthOfSchedule": 14,
      "remainingStrengthOfSchedule": null,
      "gameControl": 26
    },
    "efficiencies": {
      "overall": 66.705,
      "offense": 72.242,
      "defense": 58.501,
      "specialTeams": 35.797
    }
  },
  {
    "year": 2024,
    "team": "Louisville",
    "conference": "ACC",
    "fpi": 16.534,
    "resumeRanks": {
      "strengthOfRecord": 25,
      "fpi": 12,
      "averageWinProbability": 29,
      "strengthOfSchedule": 23,
      "remainingStrengthOfSchedule": null,
      "gameControl": 17
    },
    "efficiencies": {
      "overall": 79.476,
      "offense": 79.126,
      "defense": 66.823,
      "specialTeams": 61.497
    }
  },
  {
    "year": 2024,
    "team": "Boston College",
    "conference": "ACC",
    "fpi": 4.829,
    "resumeRanks": {
      "strengthOfRecord": 47,
      "fpi": 48,
      "averageWinProbability": 45,
      "strengthOfSchedule": 40,
      "remainingStrengthOfSchedule": null,
      "gameControl": 45
    },
    "efficiencies": {
      "overall": 61.35,
      "offense": 56.657,
      "defense": 64.403,
      "specialTeams": 40.228
    }
  },
  {
    "year": 2024,
    "team": "Duke",
    "conference": "ACC",
    "fpi": 3.686,
    "resumeRanks": {
      "strengthOfRecord": 28,
      "fpi": 55,
      "averageWinProbability": 57,
      "strengthOfSchedule": 67,
      "remainingStrengthOfSchedule": null,
      "gameControl": 58
    },
    "efficiencies": {
      "overall": 62.075,
      "offense": 41.071,
      "defense": 73.887,
      "specialTeams": 54.127
    }
  },
  {
    "year": 2024,
    "team": "NC State",
    "conference": "ACC",
    "fpi": 0.43,
    "resumeRanks": {
      "strengthOfRecord": 66,
      "fpi": 65,
      "averageWinProbability": 91,
      "strengthOfSchedule": 51,
      "remainingStrengthOfSchedule": null,
      "gameControl": 76
    },
    "efficiencies": {
      "overall": 43.632,
      "offense": 41.325,
      "defense": 49.036,
      "specialTeams": 47.981
    }
  },
  {
    "year": 2024,
    "team": "North Carolina",
    "conference": "ACC",
    "fpi": 2.602,
    "resumeRanks": {
      "strengthOfRecord": 76,
      "fpi": 60,
      "averageWinProbability": 62,
      "strengthOfSchedule": 91,
      "remainingStrengthOfSchedule": null,
      "gameControl": 66
    },
    "efficiencies": {
      "overall": 50.555,
      "offense": 55.402,
      "defense": 46.067,
      "specialTeams": 47.749
    }
  },
  {
    "year": 2024,
    "team": "Wake Forest",
    "conference": "ACC",
    "fpi": -5.059,
    "resumeRanks": {
      "strengthOfRecord": 94,
      "fpi": 88,
      "averageWinProbability": 94,
      "strengthOfSchedule": 43,
      "remainingStrengthOfSchedule": null,
      "gameControl": 73
    },
    "efficiencies": {
      "overall": 42.092,
      "offense": 45.681,
      "defense": 42.723,
      "specialTeams": 46.202
    }
  },
  {
    "year": 2024,
    "team": "Syracuse",
    "conference": "ACC",
    "fpi": 3.99,
    "resumeRanks": {
      "strengthOfRecord": 27,
      "fpi": 53,
      "averageWinProbability": 53,
      "strengthOfSchedule": 72,
      "remainingStrengthOfSchedule": null,
      "gameControl": 49
    },
    "efficiencies": {
      "overall": 59.911,
      "offense": 72.144,
      "defense": 44.673,
      "specialTeams": 32.891
    }
  },
  {
    "year": 2024,
    "team": "Pittsburgh",
    "conference": "ACC",
    "fpi": 3.991,
    "resumeRanks": {
      "strengthOfRecord": 44,
      "fpi": 52,
      "averageWinProbability": 84,
      "strengthOfSchedule": 39,
      "remainingStrengthOfSchedule": null,
      "gameControl": 64
    },
    "efficiencies": {
      "overall": 55.816,
      "offense": 49.345,
      "defense": 57.768,
      "specialTeams": 56.475
    }
  },
  {
    "year": 2024,
    "team": "Clemson",
    "conference": "ACC",
    "fpi": 15.768,
    "resumeRanks": {
      "strengthOfRecord": 21,
      "fpi": 15,
      "averageWinProbability": 9,
      "strengthOfSchedule": 35,
      "remainingStrengthOfSchedule": null,
      "gameControl": 8
    },
    "efficiencies": {
      "overall": 79.193,
      "offense": 79.078,
      "defense": 73.333,
      "specialTeams": 36.319
    }
  },
  {
    "year": 2024,
    "team": "Virginia",
    "conference": "ACC",
    "fpi": -1.289,
    "resumeRanks": {
      "strengthOfRecord": 63,
      "fpi": 74,
      "averageWinProbability": 112,
      "strengthOfSchedule": 26,
      "remainingStrengthOfSchedule": null,
      "gameControl": 78
    },
    "efficiencies": {
      "overall": 47.839,
      "offense": 40.745,
      "defense": 53.887,
      "specialTeams": 55.993
    }
  },
  {
    "year": 2024,
    "team": "Virginia Tech",
    "conference": "ACC",
    "fpi": 8.853,
    "resumeRanks": {
      "strengthOfRecord": 57,
      "fpi": 34,
      "averageWinProbability": 31,
      "strengthOfSchedule": 48,
      "remainingStrengthOfSchedule": null,
      "gameControl": 24
    },
    "efficiencies": {
      "overall": 70.514,
      "offense": 55.299,
      "defense": 74.421,
      "specialTeams": 59.153
    }
  },
  {
    "year": 2024,
    "team": "Miami",
    "conference": "ACC",
    "fpi": 17.338,
    "resumeRanks": {
      "strengthOfRecord": 14,
      "fpi": 11,
      "averageWinProbability": 20,
      "strengthOfSchedule": 55,
      "remainingStrengthOfSchedule": null,
      "gameControl": 21
    },
    "efficiencies": {
      "overall": 77.097,
      "offense": 87.084,
      "defense": 52.889,
      "specialTeams": 41.286
    }
  },
  {
    "year": 2024,
    "team": "SMU",
    "conference": "ACC",
    "fpi": 15.414,
    "resumeRanks": {
      "strengthOfRecord": 15,
      "fpi": 13,
      "averageWinProbability": 13,
      "strengthOfSchedule": 60,
      "remainingStrengthOfSchedule": null,
      "gameControl": 12
    },
    "efficiencies": {
      "overall": 78.712,
      "offense": 70.552,
      "defense": 75.601,
      "specialTeams": 56.033
    }
  },
  {
    "year": 2024,
    "team": "Arizona State",
    "conference": "Big 12",
    "fpi": 11.793,
    "resumeRanks": {
      "strengthOfRecord": 13,
      "fpi": 22,
      "averageWinProbability": 16,
      "strengthOfSchedule": 62,
      "remainingStrengthOfSchedule": null,
      "gameControl": 16
    },
    "efficiencies": {
      "overall": 78.233,
      "offense": 79.692,
      "defense": 66.688,
      "specialTeams": 47.348
    }
  },
  {
    "year": 2024,
    "team": "Arizona",
    "conference": "Big 12",
    "fpi": -3.385,
    "resumeRanks": {
      "strengthOfRecord": 88,
      "fpi": 81,
      "averageWinProbability": 116,
      "strengthOfSchedule": 50,
      "remainingStrengthOfSchedule": null,
      "gameControl": 91
    },
    "efficiencies": {
      "overall": 38.477,
      "offense": 43.057,
      "defense": 38.791,
      "specialTeams": 48.852
    }
  },
  {
    "year": 2024,
    "team": "Colorado",
    "conference": "Big 12",
    "fpi": 12.691,
    "resumeRanks": {
      "strengthOfRecord": 26,
      "fpi": 19,
      "averageWinProbability": 34,
      "strengthOfSchedule": 73,
      "remainingStrengthOfSchedule": null,
      "gameControl": 29
    },
    "efficiencies": {
      "overall": 74.938,
      "offense": 72.644,
      "defense": 69.84,
      "specialTeams": 45.06
    }
  },
  {
    "year": 2024,
    "team": "Utah",
    "conference": "Big 12",
    "fpi": 5.029,
    "resumeRanks": {
      "strengthOfRecord": 75,
      "fpi": 47,
      "averageWinProbability": 66,
      "strengthOfSchedule": 65,
      "remainingStrengthOfSchedule": null,
      "gameControl": 52
    },
    "efficiencies": {
      "overall": 60.487,
      "offense": 30.282,
      "defense": 79.81,
      "specialTeams": 59.786
    }
  },
  {
    "year": 2024,
    "team": "UCLA",
    "conference": "Big Ten",
    "fpi": 2.781,
    "resumeRanks": {
      "strengthOfRecord": 52,
      "fpi": 59,
      "averageWinProbability": 103,
      "strengthOfSchedule": 13,
      "remainingStrengthOfSchedule": null,
      "gameControl": 61
    },
    "efficiencies": {
      "overall": 54.088,
      "offense": 49.817,
      "defense": 56.439,
      "specialTeams": 50.8
    }
  },
  {
    "year": 2024,
    "team": "USC",
    "conference": "Big Ten",
    "fpi": 13.269,
    "resumeRanks": {
      "strengthOfRecord": 45,
      "fpi": 18,
      "averageWinProbability": 60,
      "strengthOfSchedule": 31,
      "remainingStrengthOfSchedule": null,
      "gameControl": 28
    },
    "efficiencies": {
      "overall": 71.782,
      "offense": 72.12,
      "defense": 62.422,
      "specialTeams": 51.818
    }
  },
  {
    "year": 2024,
    "team": "Northwestern",
    "conference": "Big Ten",
    "fpi": -5.033,
    "resumeRanks": {
      "strengthOfRecord": 85,
      "fpi": 87,
      "averageWinProbability": 107,
      "strengthOfSchedule": 36,
      "remainingStrengthOfSchedule": null,
      "gameControl": 80
    },
    "efficiencies": {
      "overall": 35.983,
      "offense": 26.972,
      "defense": 49.933,
      "specialTeams": 53.074
    }
  },
  {
    "year": 2024,
    "team": "Indiana",
    "conference": "Big Ten",
    "fpi": 18.73,
    "resumeRanks": {
      "strengthOfRecord": 8,
      "fpi": 10,
      "averageWinProbability": 1,
      "strengthOfSchedule": 68,
      "remainingStrengthOfSchedule": null,
      "gameControl": 7
    },
    "efficiencies": {
      "overall": 83.71,
      "offense": 85.132,
      "defense": 72.021,
      "specialTeams": 40.91
    }
  },
  {
    "year": 2024,
    "team": "Maryland",
    "conference": "Big Ten",
    "fpi": -0.535,
    "resumeRanks": {
      "strengthOfRecord": 82,
      "fpi": 71,
      "averageWinProbability": 111,
      "strengthOfSchedule": 18,
      "remainingStrengthOfSchedule": null,
      "gameControl": 77
    },
    "efficiencies": {
      "overall": 43.23,
      "offense": 46.603,
      "defense": 47.026,
      "specialTeams": 35.755
    }
  },
  {
    "year": 2024,
    "team": "Michigan State",
    "conference": "Big Ten",
    "fpi": -3.839,
    "resumeRanks": {
      "strengthOfRecord": 64,
      "fpi": 84,
      "averageWinProbability": 90,
      "strengthOfSchedule": 24,
      "remainingStrengthOfSchedule": null,
      "gameControl": 65
    },
    "efficiencies": {
      "overall": 44.653,
      "offense": 43.625,
      "defense": 47.171,
      "specialTeams": 52.038
    }
  },
  {
    "year": 2024,
    "team": "Michigan",
    "conference": "Big Ten",
    "fpi": 9.382,
    "resumeRanks": {
      "strengthOfRecord": 29,
      "fpi": 30,
      "averageWinProbability": 67,
      "strengthOfSchedule": 7,
      "remainingStrengthOfSchedule": null,
      "gameControl": 32
    },
    "efficiencies": {
      "overall": 64.736,
      "offense": 44.049,
      "defense": 69.52,
      "specialTeams": 75.356
    }
  },
  {
    "year": 2024,
    "team": "Minnesota",
    "conference": "Big Ten",
    "fpi": 9.315,
    "resumeRanks": {
      "strengthOfRecord": 43,
      "fpi": 31,
      "averageWinProbability": 37,
      "strengthOfSchedule": 53,
      "remainingStrengthOfSchedule": null,
      "gameControl": 31
    },
    "efficiencies": {
      "overall": 68.599,
      "offense": 55.808,
      "defense": 75.809,
      "specialTeams": 45.723
    }
  },
  {
    "year": 2024,
    "team": "Nebraska",
    "conference": "Big Ten",
    "fpi": 6.154,
    "resumeRanks": {
      "strengthOfRecord": 53,
      "fpi": 41,
      "averageWinProbability": 38,
      "strengthOfSchedule": 19,
      "remainingStrengthOfSchedule": null,
      "gameControl": 25
    },
    "efficiencies": {
      "overall": 64.984,
      "offense": 58.011,
      "defense": 69.664,
      "specialTeams": 41.381
    }
  },
  {
    "year": 2024,
    "team": "Rutgers",
    "conference": "Big Ten",
    "fpi": 3.857,
    "resumeRanks": {
      "strengthOfRecord": 54,
      "fpi": 54,
      "averageWinProbability": 59,
      "strengthOfSchedule": 74,
      "remainingStrengthOfSchedule": null,
      "gameControl": 59
    },
    "efficiencies": {
      "overall": 55.405,
      "offense": 64.09,
      "defense": 40.753,
      "specialTeams": 58.771
    }
  },
  {
    "year": 2024,
    "team": "Ohio State",
    "conference": "Big Ten",
    "fpi": 24.823,
    "resumeRanks": {
      "strengthOfRecord": 6,
      "fpi": 3,
      "averageWinProbability": 7,
      "strengthOfSchedule": 27,
      "remainingStrengthOfSchedule": null,
      "gameControl": 5
    },
    "efficiencies": {
      "overall": 87.333,
      "offense": 80.443,
      "defense": 83.601,
      "specialTeams": 49.523
    }
  },
  {
    "year": 2024,
    "team": "Penn State",
    "conference": "Big Ten",
    "fpi": 20.037,
    "resumeRanks": {
      "strengthOfRecord": 5,
      "fpi": 9,
      "averageWinProbability": 23,
      "strengthOfSchedule": 29,
      "remainingStrengthOfSchedule": null,
      "gameControl": 22
    },
    "efficiencies": {
      "overall": 81.11,
      "offense": 80.469,
      "defense": 75.103,
      "specialTeams": 36.924
    }
  },
  {
    "year": 2024,
    "team": "Washington",
    "conference": "Big Ten",
    "fpi": 5.047,
    "resumeRanks": {
      "strengthOfRecord": 46,
      "fpi": 46,
      "averageWinProbability": 83,
      "strengthOfSchedule": 12,
      "remainingStrengthOfSchedule": null,
      "gameControl": 50
    },
    "efficiencies": {
      "overall": 58.799,
      "offense": 57.598,
      "defense": 61.801,
      "specialTeams": 32.58
    }
  },
  {
    "year": 2024,
    "team": "Wisconsin",
    "conference": "Big Ten",
    "fpi": 4.781,
    "resumeRanks": {
      "strengthOfRecord": 59,
      "fpi": 49,
      "averageWinProbability": 77,
      "strengthOfSchedule": 25,
      "remainingStrengthOfSchedule": null,
      "gameControl": 46
    },
    "efficiencies": {
      "overall": 55.118,
      "offense": 42.281,
      "defense": 62.746,
      "specialTeams": 59.931
    }
  },
  {
    "year": 2024,
    "team": "Illinois",
    "conference": "Big Ten",
    "fpi": 5.208,
    "resumeRanks": {
      "strengthOfRecord": 22,
      "fpi": 45,
      "averageWinProbability": 39,
      "strengthOfSchedule": 32,
      "remainingStrengthOfSchedule": null,
      "gameControl": 41
    },
    "efficiencies": {
      "overall": 63.81,
      "offense": 64.672,
      "defense": 52.931,
      "specialTeams": 65.881
    }
  },
  {
    "year": 2024,
    "team": "Iowa",
    "conference": "Big Ten",
    "fpi": 11.144,
    "resumeRanks": {
      "strengthOfRecord": 39,
      "fpi": 23,
      "averageWinProbability": 32,
      "strengthOfSchedule": 44,
      "remainingStrengthOfSchedule": null,
      "gameControl": 36
    },
    "efficiencies": {
      "overall": 70.238,
      "offense": 48.063,
      "defense": 74.759,
      "specialTeams": 71.573
    }
  },
  {
    "year": 2024,
    "team": "Oregon",
    "conference": "Big Ten",
    "fpi": 21.125,
    "resumeRanks": {
      "strengthOfRecord": 1,
      "fpi": 6,
      "averageWinProbability": 3,
      "strengthOfSchedule": 34,
      "remainingStrengthOfSchedule": null,
      "gameControl": 3
    },
    "efficiencies": {
      "overall": 85.854,
      "offense": 85.403,
      "defense": 73.779,
      "specialTeams": 53.859
    }
  },
  {
    "year": 2024,
    "team": "Purdue",
    "conference": "Big Ten",
    "fpi": -13.836,
    "resumeRanks": {
      "strengthOfRecord": 117,
      "fpi": 122,
      "averageWinProbability": 133,
      "strengthOfSchedule": 6,
      "remainingStrengthOfSchedule": null,
      "gameControl": 114
    },
    "efficiencies": {
      "overall": 20.419,
      "offense": 29.645,
      "defense": 21.338,
      "specialTeams": 52.981
    }
  },
  {
    "year": 2024,
    "team": "Kennesaw State",
    "conference": "Conference USA",
    "fpi": -21.686,
    "resumeRanks": {
      "strengthOfRecord": 133,
      "fpi": 131,
      "averageWinProbability": 129,
      "strengthOfSchedule": 133,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 14.524,
      "offense": 11.533,
      "defense": 24.069,
      "specialTeams": 67.074
    }
  },
  {
    "year": 2024,
    "team": "Bowling Green",
    "conference": "Mid-American",
    "fpi": -3.156,
    "resumeRanks": {
      "strengthOfRecord": 81,
      "fpi": 78,
      "averageWinProbability": 30,
      "strengthOfSchedule": 84,
      "remainingStrengthOfSchedule": null,
      "gameControl": 63
    },
    "efficiencies": {
      "overall": 48.952,
      "offense": 45.874,
      "defense": 55.957,
      "specialTeams": 41.324
    }
  },
  {
    "year": 2024,
    "team": "Miami (OH)",
    "conference": "Mid-American",
    "fpi": -3.352,
    "resumeRanks": {
      "strengthOfRecord": 73,
      "fpi": 80,
      "averageWinProbability": 72,
      "strengthOfSchedule": 75,
      "remainingStrengthOfSchedule": null,
      "gameControl": 90
    },
    "efficiencies": {
      "overall": 46.329,
      "offense": 38.021,
      "defense": 53.012,
      "specialTeams": 55.962
    }
  },
  {
    "year": 2024,
    "team": "Ohio",
    "conference": "Mid-American",
    "fpi": -1.023,
    "resumeRanks": {
      "strengthOfRecord": 51,
      "fpi": 73,
      "averageWinProbability": 26,
      "strengthOfSchedule": 121,
      "remainingStrengthOfSchedule": 6,
      "gameControl": 67
    },
    "efficiencies": {
      "overall": 54.734,
      "offense": 51.667,
      "defense": 57.327,
      "specialTeams": 46.616
    }
  },
  {
    "year": 2024,
    "team": "Akron",
    "conference": "Mid-American",
    "fpi": -15.896,
    "resumeRanks": {
      "strengthOfRecord": 111,
      "fpi": 124,
      "averageWinProbability": 110,
      "strengthOfSchedule": 54,
      "remainingStrengthOfSchedule": null,
      "gameControl": 111
    },
    "efficiencies": {
      "overall": 25.51,
      "offense": 29.574,
      "defense": 28.571,
      "specialTeams": 53.83
    }
  },
  {
    "year": 2024,
    "team": "Ball State",
    "conference": "Mid-American",
    "fpi": -18.001,
    "resumeRanks": {
      "strengthOfRecord": 123,
      "fpi": 126,
      "averageWinProbability": 109,
      "strengthOfSchedule": 87,
      "remainingStrengthOfSchedule": null,
      "gameControl": 113
    },
    "efficiencies": {
      "overall": 23.364,
      "offense": 37.223,
      "defense": 18.686,
      "specialTeams": 52.051
    }
  },
  {
    "year": 2024,
    "team": "Buffalo",
    "conference": "Mid-American",
    "fpi": -10.361,
    "resumeRanks": {
      "strengthOfRecord": 70,
      "fpi": 108,
      "averageWinProbability": 70,
      "strengthOfSchedule": 116,
      "remainingStrengthOfSchedule": 7,
      "gameControl": 95
    },
    "efficiencies": {
      "overall": 39.252,
      "offense": 33.654,
      "defense": 45.998,
      "specialTeams": 57.803
    }
  },
  {
    "year": 2024,
    "team": "Central Michigan",
    "conference": "Mid-American",
    "fpi": -14.808,
    "resumeRanks": {
      "strengthOfRecord": 120,
      "fpi": 123,
      "averageWinProbability": 118,
      "strengthOfSchedule": 125,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 22.505,
      "offense": 23.257,
      "defense": 30.33,
      "specialTeams": 49.931
    }
  },
  {
    "year": 2024,
    "team": "Eastern Michigan",
    "conference": "Mid-American",
    "fpi": -13.481,
    "resumeRanks": {
      "strengthOfRecord": 114,
      "fpi": 119,
      "averageWinProbability": 93,
      "strengthOfSchedule": 128,
      "remainingStrengthOfSchedule": null,
      "gameControl": 121
    },
    "efficiencies": {
      "overall": 26.84,
      "offense": 26.714,
      "defense": 34.766,
      "specialTeams": 54.009
    }
  },
  {
    "year": 2024,
    "team": "Kent State",
    "conference": "Mid-American",
    "fpi": -31.206,
    "resumeRanks": {
      "strengthOfRecord": 134,
      "fpi": 134,
      "averageWinProbability": 134,
      "strengthOfSchedule": 49,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 4.62,
      "offense": 7.815,
      "defense": 9.994,
      "specialTeams": 41.858
    }
  },
  {
    "year": 2024,
    "team": "Northern Illinois",
    "conference": "Mid-American",
    "fpi": -4.256,
    "resumeRanks": {
      "strengthOfRecord": 83,
      "fpi": 86,
      "averageWinProbability": 63,
      "strengthOfSchedule": 83,
      "remainingStrengthOfSchedule": null,
      "gameControl": 87
    },
    "efficiencies": {
      "overall": 46.732,
      "offense": 34.378,
      "defense": 64.438,
      "specialTeams": 43.51
    }
  },
  {
    "year": 2024,
    "team": "Toledo",
    "conference": "Mid-American",
    "fpi": -5.318,
    "resumeRanks": {
      "strengthOfRecord": 92,
      "fpi": 91,
      "averageWinProbability": 41,
      "strengthOfSchedule": 131,
      "remainingStrengthOfSchedule": null,
      "gameControl": 82
    },
    "efficiencies": {
      "overall": 43.159,
      "offense": 33.851,
      "defense": 52.717,
      "specialTeams": 56.909
    }
  },
  {
    "year": 2024,
    "team": "Western Michigan",
    "conference": "Mid-American",
    "fpi": -10.952,
    "resumeRanks": {
      "strengthOfRecord": 103,
      "fpi": 111,
      "averageWinProbability": 87,
      "strengthOfSchedule": 77,
      "remainingStrengthOfSchedule": 5,
      "gameControl": 104
    },
    "efficiencies": {
      "overall": 37.661,
      "offense": 53.267,
      "defense": 24.968,
      "specialTeams": 62.263
    }
  },
  {
    "year": 2024,
    "team": "San Diego State",
    "conference": "Mountain West",
    "fpi": -13.599,
    "resumeRanks": {
      "strengthOfRecord": 124,
      "fpi": 121,
      "averageWinProbability": 113,
      "strengthOfSchedule": 105,
      "remainingStrengthOfSchedule": null,
      "gameControl": 121
    },
    "efficiencies": {
      "overall": 21.634,
      "offense": 18.434,
      "defense": 30.611,
      "specialTeams": 67.635
    }
  },
  {
    "year": 2024,
    "team": "San Jos\u00e9 State",
    "conference": "Mountain West",
    "fpi": -5.133,
    "resumeRanks": {
      "strengthOfRecord": 80,
      "fpi": 89,
      "averageWinProbability": 65,
      "strengthOfSchedule": 117,
      "remainingStrengthOfSchedule": 11,
      "gameControl": 84
    },
    "efficiencies": {
      "overall": 42.709,
      "offense": 44.903,
      "defense": 47.684,
      "specialTeams": 35.133
    }
  },
  {
    "year": 2024,
    "team": "Colorado State",
    "conference": "Mountain West",
    "fpi": -7.622,
    "resumeRanks": {
      "strengthOfRecord": 58,
      "fpi": 101,
      "averageWinProbability": 40,
      "strengthOfSchedule": 70,
      "remainingStrengthOfSchedule": null,
      "gameControl": 69
    },
    "efficiencies": {
      "overall": 43.334,
      "offense": 34.559,
      "defense": 49.403,
      "specialTeams": 65.152
    }
  },
  {
    "year": 2024,
    "team": "Hawai'i",
    "conference": "Mountain West",
    "fpi": -11.741,
    "resumeRanks": {
      "strengthOfRecord": 107,
      "fpi": 114,
      "averageWinProbability": 86,
      "strengthOfSchedule": 115,
      "remainingStrengthOfSchedule": null,
      "gameControl": 107
    },
    "efficiencies": {
      "overall": 32.71,
      "offense": 35.004,
      "defense": 37.024,
      "specialTeams": 49.876
    }
  },
  {
    "year": 2024,
    "team": "Boise State",
    "conference": "Mountain West",
    "fpi": 10.993,
    "resumeRanks": {
      "strengthOfRecord": 10,
      "fpi": 25,
      "averageWinProbability": 8,
      "strengthOfSchedule": 81,
      "remainingStrengthOfSchedule": null,
      "gameControl": 14
    },
    "efficiencies": {
      "overall": 75.687,
      "offense": 78.889,
      "defense": 64.483,
      "specialTeams": 42.529
    }
  },
  {
    "year": 2024,
    "team": "New Mexico",
    "conference": "Mountain West",
    "fpi": -10.018,
    "resumeRanks": {
      "strengthOfRecord": 109,
      "fpi": 106,
      "averageWinProbability": 106,
      "strengthOfSchedule": 118,
      "remainingStrengthOfSchedule": null,
      "gameControl": 119
    },
    "efficiencies": {
      "overall": 34.353,
      "offense": 67.849,
      "defense": 15.036,
      "specialTeams": 42.247
    }
  },
  {
    "year": 2024,
    "team": "Fresno State",
    "conference": "Mountain West",
    "fpi": -2.996,
    "resumeRanks": {
      "strengthOfRecord": 93,
      "fpi": 77,
      "averageWinProbability": 50,
      "strengthOfSchedule": 103,
      "remainingStrengthOfSchedule": null,
      "gameControl": 68
    },
    "efficiencies": {
      "overall": 48.16,
      "offense": 39.377,
      "defense": 59.765,
      "specialTeams": 37.79
    }
  },
  {
    "year": 2024,
    "team": "Utah State",
    "conference": "Mountain West",
    "fpi": -10.773,
    "resumeRanks": {
      "strengthOfRecord": 112,
      "fpi": 110,
      "averageWinProbability": 98,
      "strengthOfSchedule": 92,
      "remainingStrengthOfSchedule": null,
      "gameControl": 102
    },
    "efficiencies": {
      "overall": 26.445,
      "offense": 42.504,
      "defense": 21.003,
      "specialTeams": 45.961
    }
  },
  {
    "year": 2024,
    "team": "Air Force",
    "conference": "Mountain West",
    "fpi": -9.432,
    "resumeRanks": {
      "strengthOfRecord": 108,
      "fpi": 105,
      "averageWinProbability": 100,
      "strengthOfSchedule": 112,
      "remainingStrengthOfSchedule": null,
      "gameControl": 115
    },
    "efficiencies": {
      "overall": 29.604,
      "offense": 30.957,
      "defense": 41.263,
      "specialTeams": 34.945
    }
  },
  {
    "year": 2024,
    "team": "UNLV",
    "conference": "Mountain West",
    "fpi": 5.991,
    "resumeRanks": {
      "strengthOfRecord": 36,
      "fpi": 42,
      "averageWinProbability": 18,
      "strengthOfSchedule": 88,
      "remainingStrengthOfSchedule": null,
      "gameControl": 43
    },
    "efficiencies": {
      "overall": 71.232,
      "offense": 57.654,
      "defense": 72.272,
      "specialTeams": 64.179
    }
  },
  {
    "year": 2024,
    "team": "Nevada",
    "conference": "Mountain West",
    "fpi": -8.417,
    "resumeRanks": {
      "strengthOfRecord": 121,
      "fpi": 103,
      "averageWinProbability": 108,
      "strengthOfSchedule": 79,
      "remainingStrengthOfSchedule": null,
      "gameControl": 108
    },
    "efficiencies": {
      "overall": 32.498,
      "offense": 47.2,
      "defense": 30.419,
      "specialTeams": 32.833
    }
  },
  {
    "year": 2024,
    "team": "Wyoming",
    "conference": "Mountain West",
    "fpi": -11.258,
    "resumeRanks": {
      "strengthOfRecord": 118,
      "fpi": 112,
      "averageWinProbability": 125,
      "strengthOfSchedule": 97,
      "remainingStrengthOfSchedule": null,
      "gameControl": 125
    },
    "efficiencies": {
      "overall": 27.085,
      "offense": 22.043,
      "defense": 41.722,
      "specialTeams": 50.851
    }
  },
  {
    "year": 2024,
    "team": "Auburn",
    "conference": "SEC",
    "fpi": 9.659,
    "resumeRanks": {
      "strengthOfRecord": 65,
      "fpi": 29,
      "averageWinProbability": 68,
      "strengthOfSchedule": 22,
      "remainingStrengthOfSchedule": null,
      "gameControl": 47
    },
    "efficiencies": {
      "overall": 63.424,
      "offense": 56.985,
      "defense": 65.452,
      "specialTeams": 46.626
    }
  },
  {
    "year": 2024,
    "team": "Arkansas",
    "conference": "SEC",
    "fpi": 8.19,
    "resumeRanks": {
      "strengthOfRecord": 42,
      "fpi": 36,
      "averageWinProbability": 61,
      "strengthOfSchedule": 20,
      "remainingStrengthOfSchedule": null,
      "gameControl": 34
    },
    "efficiencies": {
      "overall": 65.787,
      "offense": 60.714,
      "defense": 66.155,
      "specialTeams": 45.94
    }
  },
  {
    "year": 2024,
    "team": "Florida",
    "conference": "SEC",
    "fpi": 11.901,
    "resumeRanks": {
      "strengthOfRecord": 24,
      "fpi": 21,
      "averageWinProbability": 47,
      "strengthOfSchedule": 5,
      "remainingStrengthOfSchedule": null,
      "gameControl": 18
    },
    "efficiencies": {
      "overall": 71.717,
      "offense": 58.466,
      "defense": 70.419,
      "specialTeams": 67.15
    }
  },
  {
    "year": 2024,
    "team": "Georgia",
    "conference": "SEC",
    "fpi": 22.091,
    "resumeRanks": {
      "strengthOfRecord": 2,
      "fpi": 5,
      "averageWinProbability": 36,
      "strengthOfSchedule": 1,
      "remainingStrengthOfSchedule": null,
      "gameControl": 11
    },
    "efficiencies": {
      "overall": 82.861,
      "offense": 79.935,
      "defense": 73.308,
      "specialTeams": 59.572
    }
  },
  {
    "year": 2024,
    "team": "Kentucky",
    "conference": "SEC",
    "fpi": 4.707,
    "resumeRanks": {
      "strengthOfRecord": 62,
      "fpi": 50,
      "averageWinProbability": 92,
      "strengthOfSchedule": 3,
      "remainingStrengthOfSchedule": null,
      "gameControl": 54
    },
    "efficiencies": {
      "overall": 54.684,
      "offense": 41.39,
      "defense": 62.472,
      "specialTeams": 62.769
    }
  },
  {
    "year": 2024,
    "team": "LSU",
    "conference": "SEC",
    "fpi": 13.515,
    "resumeRanks": {
      "strengthOfRecord": 17,
      "fpi": 17,
      "averageWinProbability": 49,
      "strengthOfSchedule": 10,
      "remainingStrengthOfSchedule": null,
      "gameControl": 20
    },
    "efficiencies": {
      "overall": 71.849,
      "offense": 75.763,
      "defense": 61.497,
      "specialTeams": 39.011
    }
  },
  {
    "year": 2024,
    "team": "Missouri",
    "conference": "SEC",
    "fpi": 12.197,
    "resumeRanks": {
      "strengthOfRecord": 19,
      "fpi": 20,
      "averageWinProbability": 51,
      "strengthOfSchedule": 28,
      "remainingStrengthOfSchedule": null,
      "gameControl": 39
    },
    "efficiencies": {
      "overall": 68.028,
      "offense": 61.356,
      "defense": 72.874,
      "specialTeams": 37.108
    }
  },
  {
    "year": 2024,
    "team": "Ole Miss",
    "conference": "SEC",
    "fpi": 20.608,
    "resumeRanks": {
      "strengthOfRecord": 18,
      "fpi": 8,
      "averageWinProbability": 5,
      "strengthOfSchedule": 33,
      "remainingStrengthOfSchedule": null,
      "gameControl": 2
    },
    "efficiencies": {
      "overall": 84.235,
      "offense": 76.596,
      "defense": 81.866,
      "specialTeams": 47.73
    }
  },
  {
    "year": 2024,
    "team": "Oklahoma",
    "conference": "SEC",
    "fpi": 10.943,
    "resumeRanks": {
      "strengthOfRecord": 30,
      "fpi": 26,
      "averageWinProbability": 82,
      "strengthOfSchedule": 4,
      "remainingStrengthOfSchedule": null,
      "gameControl": 30
    },
    "efficiencies": {
      "overall": 65.083,
      "offense": 38.944,
      "defense": 80.167,
      "specialTeams": 57.918
    }
  },
  {
    "year": 2024,
    "team": "Vanderbilt",
    "conference": "SEC",
    "fpi": 6.463,
    "resumeRanks": {
      "strengthOfRecord": 40,
      "fpi": 39,
      "averageWinProbability": 75,
      "strengthOfSchedule": 8,
      "remainingStrengthOfSchedule": null,
      "gameControl": 37
    },
    "efficiencies": {
      "overall": 63.309,
      "offense": 66.631,
      "defense": 47.406,
      "specialTeams": 72.026
    }
  },
  {
    "year": 2024,
    "team": "Texas A&M",
    "conference": "SEC",
    "fpi": 14.297,
    "resumeRanks": {
      "strengthOfRecord": 20,
      "fpi": 16,
      "averageWinProbability": 27,
      "strengthOfSchedule": 9,
      "remainingStrengthOfSchedule": null,
      "gameControl": 13
    },
    "efficiencies": {
      "overall": 76.763,
      "offense": 68.737,
      "defense": 71.579,
      "specialTeams": 64.836
    }
  },
  {
    "year": 2024,
    "team": "Texas",
    "conference": "SEC",
    "fpi": 26.107,
    "resumeRanks": {
      "strengthOfRecord": 3,
      "fpi": 1,
      "averageWinProbability": 6,
      "strengthOfSchedule": 21,
      "remainingStrengthOfSchedule": null,
      "gameControl": 1
    },
    "efficiencies": {
      "overall": 88.25,
      "offense": 73.85,
      "defense": 92.32,
      "specialTeams": 35.538
    }
  },
  {
    "year": 2024,
    "team": "Alabama",
    "conference": "SEC",
    "fpi": 23.933,
    "resumeRanks": {
      "strengthOfRecord": 9,
      "fpi": 4,
      "averageWinProbability": 10,
      "strengthOfSchedule": 16,
      "remainingStrengthOfSchedule": null,
      "gameControl": 6
    },
    "efficiencies": {
      "overall": 85.057,
      "offense": 77.281,
      "defense": 79.955,
      "specialTeams": 59.628
    }
  },
  {
    "year": 2024,
    "team": "Mississippi State",
    "conference": "SEC",
    "fpi": 0.192,
    "resumeRanks": {
      "strengthOfRecord": 105,
      "fpi": 67,
      "averageWinProbability": 128,
      "strengthOfSchedule": 2,
      "remainingStrengthOfSchedule": null,
      "gameControl": 92
    },
    "efficiencies": {
      "overall": 42.441,
      "offense": 55.752,
      "defense": 32.43,
      "specialTeams": 52.743
    }
  },
  {
    "year": 2024,
    "team": "South Carolina",
    "conference": "SEC",
    "fpi": 14.834,
    "resumeRanks": {
      "strengthOfRecord": 11,
      "fpi": 14,
      "averageWinProbability": 15,
      "strengthOfSchedule": 15,
      "remainingStrengthOfSchedule": null,
      "gameControl": 10
    },
    "efficiencies": {
      "overall": 76.206,
      "offense": 60.762,
      "defense": 80.864,
      "specialTeams": 51.02
    }
  },
  {
    "year": 2024,
    "team": "Tennessee",
    "conference": "SEC",
    "fpi": 20.786,
    "resumeRanks": {
      "strengthOfRecord": 7,
      "fpi": 7,
      "averageWinProbability": 11,
      "strengthOfSchedule": 30,
      "remainingStrengthOfSchedule": null,
      "gameControl": 9
    },
    "efficiencies": {
      "overall": 83.706,
      "offense": 67.16,
      "defense": 87.119,
      "specialTeams": 52.677
    }
  }
]